import { useTheme } from '@mui/material';
import { t } from 'i18next';
import styles from '../styles/QuestionWrapper.module.css';
const TestScoreSummery = ({ data }) => {
    const theme = useTheme();
    console.log(data, 'data1235')
    const evenRowStyle = {
        backgroundColor: '#f2f2f2',
    };

    return (
        <table style={{ background: '#fff', borderRadius: '5px', boxShadow: ' 0 4px 4px 0 rgba(0, 0, 0, 0.05)', fontFamily: 'Poppins' }}>
            <thead className={styles.tableHeadings} style={{ color: '#001124', fontWeight: 'bold', borderBottom: '1px solid #09090980 50%' }}>
                <tr>
                    {/* <th>ID</th> */}
                    <th style={{ padding: '0px 10px 0px 12px' }}>{t("Section")}</th>
                    <th style={{ padding: '0px 10px 0px 12px', textAlign: 'center' }}>{t("Positive")}</th>
                    <th style={{ padding: '0px 10px 0px 12px', textAlign: 'center' }}>{t("Negative")}</th>
                    <th style={{ padding: '0px 10px 0px 12px', textAlign: 'center' }}>{t("Your Score")}</th>
                    {/* <th style={{ padding: '0px 10px 0px 12px', textAlign: 'center' }}>{t("Total Section Score")}</th> */}
                </tr>
            </thead>
            <tbody>
                {console.log("dataaka", data)}
                {data && data?.length > 0 ?
                    data.map((section, index) => (
                        <tr key={section.id} style={index % 2 === 0 ? evenRowStyle : {}}>
                            <td style={{ padding: '0px 0px 0px 12px' }}>{section?.text}</td>
                            <td style={{ padding: '0px 0px 0px 12px', textAlign: 'center' }}>{section?.positiveScore}</td>
                            <td style={{ padding: '0px 0px 0px 12px', textAlign: 'center' }}>{section?.negativeScore}</td>
                            <td style={{ padding: '0px 0px 0px 12px', textAlign: 'center' }}>{`${section?.poolScore} / ${section?.totalPoolScore}`}</td>
                            {/* <td style={{ padding: '0px 0px 0px 12px', textAlign: 'center' }}>{section?.totalPoolScore}</td> */}
                        </tr>
                    ))
                    : <tr>
                        <td colspan="4" style={{ textAlign: 'center' }}>
                            <h6 >No Record Found</h6>
                        </td>
                    </tr>

                }
            </tbody>
        </table>
    );
};

export default TestScoreSummery;